import { request } from '../request'

export function getList (data) {
  return request({
    url: '/website/notice',
    method: 'get',
    data
  })
}

// 获取栏目名称树形结构
export function getItemTree () {
  const data = { status: 1 }
  return request({
    url: '/website/category/tree',
    method: 'get',
    data
  })
}

// 获取栏目名称树形结构
export function addNotice (data) {
    return request({
      url: '/website/notice',
      method: 'POST',
      data
    })
  }

  // 获取栏目名称树形结构
export function deldeteNotice (data) {
    return request({
      url: '/website/notice/' + data.id,
      method: 'DELETE'
    })
  }

 // 获取栏目名称树形结构
export function getNoticeInfo (data) {
    return request({
      url: '/website/notice/' + data.id,
      method: 'GET'
    })
  }

// 获取栏目名称树形结构
export function editNotice (data) {
    return request({
      url: '/website/notice/' + data.id,
      method: 'PUT',
      data
    })
  }

// 发布
export function editStatus (data) {
    return request({
      url: '/website/notice/publish/' + data.id,
      method: 'PUT'
    })
  }

// 取消发布
export function cancelStatus (data) {
    return request({
      url: '/website/notice/unPublish/' + data.id,
      method: 'PUT'
    })
  }

// 置顶
export function editTop (data) {
    return request({
      url: '/website/notice/top/' + data.id,
      method: 'PUT'
    })
  }

// 取消置顶
export function cancelTop (data) {
    return request({
      url: '/website/notice/unTop/' + data.id,
      method: 'PUT'
    })
  }
